var map = {
	"./en-US": "743d",
	"./en-US.js": "743d",
	"./en-US/common": "dd24",
	"./en-US/common.js": "dd24",
	"./en-US/setting": "5030",
	"./en-US/setting.js": "5030",
	"./zh-CN": "2807",
	"./zh-CN.js": "2807",
	"./zh-CN/common": "2c50",
	"./zh-CN/common.js": "2c50",
	"./zh-CN/setting": "5436",
	"./zh-CN/setting.js": "5436"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "4aa4";
module.exports = webpackAsyncContext;